import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  supportCardsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    gap: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      gap: theme.spacing(2),
      flexDirection: 'column',
      alignItems: 'stretch',
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        gap: theme.spacing(2),
        flexDirection: 'column',
        alignItems: 'stretch',
      }),
    },
  },
}));
